module.exports = __webpack_public_path__ + "fonts/boxicons.f46ca69e.ttf";